import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

function isBlank(value) {
  return (_.isNil(value) || _.isNaN(value) || (_.isString(value) && _.isEmpty(value.trim())));
}

export const FollowUpLineQuestion = ({ question, disabled, onAnswerChange }) => {
  const rdn = Math.random();
  const [checked, setChecked] = useState(question.answer.checked);

  return (
    <div className="o-follow-up-question">
      <div className="o-follow-up-question__checkbox">
        <input
          id={`input-${rdn}`}
          className="o-follow-up-question__checkbox"
          type="checkbox"
          disabled={disabled}
          checked={checked}
          onChange={() => {
            setChecked(!checked);
            question.answer.checked = !checked;
            if (onAnswerChange) onAnswerChange();
          }}
        />
      </div>

      <div className="o-follow-up-question__label">
        <label htmlFor={`input-${rdn}`}>
          {question.title}
          {!isBlank(question.info_link) ? <span className='o-follow-up-question__info'><a href={question.info_link} target='_blank' rel="noreferrer"><span role="img" aria-label="info">ⓘ</span></a></span> : null}
        </label>
      </div>
    </div>
  )
}

FollowUpLineQuestion.propTypes = {
  question: PropTypes.object.isRequired,
  disabled: PropTypes.bool.isRequired,
  onAnswerChange: PropTypes.func,
}
